import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { paymentsApi } from '../../api/endpoints/payments';
import {
  PaymentRecordRequest,
  PaymentVerificationRequest,
  MpesaSTKPushRequest,
} from '../../api/types/payment.types';

export const useRecordPayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: PaymentRecordRequest) => paymentsApi.record(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['loans'] });
      queryClient.invalidateQueries({ queryKey: ['payments'] });
    },
  });
};

export const useVerifyPayment = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: PaymentVerificationRequest) => paymentsApi.verify(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['payments'] });
    },
  });
};

export const useLoanPayments = (loanId: string) => {
  return useQuery({
    queryKey: ['loanPayments', loanId],
    queryFn: () => paymentsApi.getByLoan(loanId),
    enabled: !!loanId,
  });
};

export const useMpesaSTKPush = () => {
  return useMutation({
    mutationFn: (data: MpesaSTKPushRequest) => paymentsApi.mpesaSTKPush(data),
  });
};
